import { FC } from 'react';
import { styled } from '@robocorp/theme';
import { Button } from '@robocorp/components';
import { IconChevronRight } from '@robocorp/icons/iconic';

const StyledButton = styled(Button)`
  > div.styled-container {
    display: none;
    padding: 0;
  }
`;

export const CellArrow: FC = () => (
  <StyledButton icon={IconChevronRight} variant="ghost" aria-label="action" className="badge" />
);
